import * as _ from "lodash"
import * as ACTIONS from "./types"
import { handleErrors } from "../../utils/file_handling"
import { extras } from "../../models/extras"
import { getRandom } from "services/cachedRandom/random.service"

export const loadExtras = storeName => dispatch => {
  // First flag that we're beginning to fetch data
  dispatch(extras_fetch_begin())
  fetch("./images/model/extras.json")
    .then(handleErrors)
    .then(data => data.json())
    .then(_data => {
      let newData = _.cloneDeep(extras)

      // HACK!!! THIS IS A HACK!!!
      // flip a coin for each extra with altCost
      // go through each possible extras... funfunfun
      // Global Extras
      newData = Object.entries(newData).reduce(
        (dataObj, [storeID, storeExtras]) => {
          storeExtras.GLOBAL_EXTRAS = Object.entries(
            storeExtras.GLOBAL_EXTRAS
          ).reduce((newObj, [extraID, extra]) => {
            if ("altCost" in extra) {
              // flip the coin
              const coin = getRandom(
                `extras-pricing-global-extras-${extraID}`,
                [false, true]
              )
              if (coin) {
                extra.cost = extra.altCost
              }
            }
            return {
              ...newObj,
              [extraID]: extra
            }
          }, {})

          return {
            ...dataObj,
            [storeID]: storeExtras
          }
        },
        {}
      )

      return newData
    })
    .then(data => dispatch(extras_fetch_success(data[storeName])))
    .catch(err => dispatch(extras_fetch_failed(err)))
}

const extras_fetch_begin = () => ({
  type: ACTIONS.FETCH_EXTRAS_BEGIN
})

const extras_fetch_success = data => ({
  type: ACTIONS.FETCH_EXTRAS_SUCCESS,
  payload: data
})

const extras_fetch_failed = err => ({
  type: ACTIONS.FETCH_EXTRAS_FAILURE,
  payload: err
})
